import Decimal from 'decimal.js';
import compact from 'lodash/compact';
import { utils } from '..';
import { pluralizeUnitName } from "../unit-name.utils";
import { numberAndUnit } from "../../infra/utils";
export let PaymentBulletIntent;

(function (PaymentBulletIntent) {
  PaymentBulletIntent["ZeroCap"] = "zero-cap";
  PaymentBulletIntent["RequiresClientApproval"] = "requires-client-approval";
  PaymentBulletIntent["Preapproved1"] = "preapproved1";
  PaymentBulletIntent["Preapproved2"] = "preapproved2";
  PaymentBulletIntent["Range"] = "range";
  PaymentBulletIntent["AutoPayment"] = "auto-payment";
  PaymentBulletIntent["ApprovalPayment"] = "approval-payment";
  PaymentBulletIntent["PositiveNetTerms"] = "positive-net-terms";
  PaymentBulletIntent["ZeroNetTerms"] = "zero-net-terms";
})(PaymentBulletIntent || (PaymentBulletIntent = {}));

export function getServicePaymentText(serviceData, agreementData) {
  const {
    unitName,
    unitCap,
    maxPrice
  } = serviceData;
  const hasPositiveCap = !!unitCap && unitCap.greaterThan(0);
  const hasZeroCap = !!unitCap && unitCap.eq(0);
  const isRangePrice = !!maxPrice;
  const agreementBullets = compact([agreementData && (agreementData.autoPayment ? autoPaymentBullet() : approvalPaymentBullet()), agreementData && (agreementData.netTerms > 0 ? positiveNetTermsBullet(agreementData.netTerms) : zeroNetTermsBullet())]);

  if (hasZeroCap) {
    return [zeroCapBullet(unitName), requiresClientApprovalBullet()];
  }

  if (hasPositiveCap) {
    return agreementBullets.concat([preapprovedBullet1(unitCap, unitName), preapprovedBullet2(unitName)]);
  }

  if (isRangePrice) {
    return agreementBullets.concat(rangeBullet(maxPrice));
  }

  return agreementBullets;
}

const zeroCapBullet = unitName => ({
  intent: PaymentBulletIntent.ZeroCap,
  text: "No preapproved number of ".concat(pluralizeUnitName(new Decimal(0), unitName), " has been set")
});

const requiresClientApprovalBullet = () => ({
  intent: PaymentBulletIntent.RequiresClientApproval,
  text: 'Payment will be processed once the invoice is approved by the client'
});

const preapprovedBullet1 = (unitCap, unitName) => ({
  intent: PaymentBulletIntent.Preapproved1,
  text: "".concat(unitCap, " preapproved ").concat(pluralizeUnitName(unitCap, unitName))
});

const preapprovedBullet2 = unitName => ({
  intent: PaymentBulletIntent.Preapproved2,
  text: "Exceeding the preapproved ".concat(pluralizeUnitName(new Decimal(2), unitName), " will require approval")
});

const rangeBullet = maxPrice => ({
  intent: PaymentBulletIntent.Range,
  text: "Payment above ".concat(utils.formatDollarAmount(maxPrice.toDP(2).toNumber()), " will require approval")
});

const autoPaymentBullet = () => ({
  intent: PaymentBulletIntent.AutoPayment,
  text: 'Payment will be automatically processed'
});

const approvalPaymentBullet = () => ({
  intent: PaymentBulletIntent.ApprovalPayment,
  text: 'Payment requires approval'
});

const positiveNetTermsBullet = netTerms => ({
  intent: PaymentBulletIntent.PositiveNetTerms,
  text: "Payment will be processed within ".concat(numberAndUnit(netTerms, 'day'))
});

const zeroNetTermsBullet = () => ({
  intent: PaymentBulletIntent.ZeroNetTerms,
  text: 'Payment will be processed once the invoice is issued'
});